import find from 'lodash/find';
import get from 'lodash/get';
import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

import { store } from 'src/index';

export const IsEmailDomainUnique =
  (validationOptions?: ValidationOptions) => (object: Object, propertyName: string) => {
    registerDecorator({
      name: 'taken',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate: (currentPropertyValue: string, args: ValidationArguments) => {
          const emailDomain = get(args, 'object.content.customerDomain', '');

          if (!emailDomain) {
            return true;
          }

          const state = store.getState();
          const emailDomains = get(state, 'emailDomains.values', []);

          return !find(emailDomains, domain => get(domain, 'content.customerDomain') === emailDomain);
        },
        defaultMessage: () => 'This email sending domain is already in use. Try another.',
      },
    });
  };
